import React, { useState } from 'react';
import { ASSET_URL } from '../../../../helper/api_url';
import ImageViewer from '../../../../components/ImageViewer';
import { getTrialStatus, getStatusBadge, openGoogleMap, truncateText } from './enquiryUtils';
import { AddressModal } from './AddressModal';

export const SchoolInfoCell = ({ row }) => {
    const [showAddressModal, setShowAddressModal] = useState(false);

    const imageUrl = ASSET_URL + row.avatar;
    const trialStatus = getTrialStatus(row.tryal_date, row.tryal_period);
    const status = getStatusBadge(row.status);
    const address = row.address_1 || row.address || '';
    const truncated = truncateText(address, 28);

    return (
        <div className="d-flex align-items-start gap-2 py-1" style={{ minWidth: '220px', maxWidth: '340px' }}>
            {/* School Avatar with Status Bubble Indicator */}
            <div className="avatar-status-wrapper mt-1 flex-shrink-0">
                <ImageViewer image={imageUrl}>
                    <img
                        className="rounded-circle border"
                        style={{ width: '38px', height: '38px', objectFit: 'cover', cursor: 'pointer' }}
                        src={imageUrl}
                        alt="School"
                    />
                </ImageViewer>
                <span
                    className={`status-bubble status-bubble-${status.color}`}
                    title={`Status: ${status.label}`}
                />
            </div>

            <div className="d-flex flex-column text-start" style={{ minWidth: 0, width: '100%' }}>
                {/* 1. School Name in Bold + Trial Badge */}
                <div className="d-flex align-items-center gap-1.5 flex-wrap">
                    <span className="fw-bold text-dark fs-13 lh-sm text-truncate" title={row.name}>
                        {row.name}
                    </span>
                    {trialStatus && (
                        <span className={`badge ${trialStatus.badgeClass} fs-10 py-0.5 px-1.5`}>
                            {trialStatus.label}
                        </span>
                    )}
                </div>

                {/* 2. Address in simple text with ellipsis (...) clickable for full address modal */}
                <div className="fs-12 text-muted lh-sm mt-0.5">
                    {address ? (
                        <span>
                            {truncated.isTruncated ? (
                                <>
                                    <span>{truncated.displayText}</span>
                                    <span
                                        className="badge bg-soft-primary text-primary ms-1 cursor-pointer address-dot-trigger"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setShowAddressModal(true);
                                        }}
                                        title="Click to view full address"
                                    >
                                        ...
                                    </span>
                                </>
                            ) : (
                                <span>{truncated.displayText}</span>
                            )}
                        </span>
                    ) : (
                        <span className="fst-italic text-muted fs-11">No address</span>
                    )}
                </div>

                {/* 3. District in <small> tag + Map icon beside it */}
                <div className="d-flex align-items-center gap-1 mt-0.5">
                    <small className="text-secondary fs-11">
                        <i className="ri-building-line text-muted me-1"></i>
                        {row.district || 'District N/A'}
                    </small>

                    {row.feedback ? (
                        <button
                            type="button"
                            className="btn btn-link p-0 text-danger map-pin-icon-btn ms-1 border-0"
                            onClick={(e) => {
                                e.stopPropagation();
                                openGoogleMap(row.feedback);
                            }}
                            title="Open Google Map Location"
                            style={{ lineHeight: 1 }}
                        >
                            <i className="ri-map-pin-2-fill fs-13"></i>
                        </button>
                    ) : null}
                </div>
            </div>

            {/* Address Modal */}
            {showAddressModal && (
                <AddressModal
                    show={showAddressModal}
                    onHide={() => setShowAddressModal(false)}
                    schoolName={row.name}
                    address={address}
                    district={row.district}
                    mapUrl={row.feedback}
                />
            )}
        </div>
    );
};

export default SchoolInfoCell;
